import { IConfigService } from "./IConfigService";
import { BaseService } from "../base/BaseService";
import { IConfigRepository } from "./IConfigRepository";

export class ConfigService extends BaseService implements IConfigService {
    private configRepository: IConfigRepository;
    constructor() {
        super();
        this.configRepository = this.dependencies.configRepository;
    }
    getConfig(key: string): string {
        return this.configRepository.getConfig(key);
    }
    setConfig(key: string, value: string): void {
        this.configRepository.setConfig(key, value);
    }
}
